export default __webpack_public_path__ + "static/char-v-36-zh-Hant-f1f991256ea0976fab519b174156de34.mp4";